import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Card, CardContent, CardMedia } from '../../Generic/Card';
import Typography from '../../Generic/Typography';
import { Button } from '../../Generic/Button';
import cardStyles from './Homecarousel-tw-styles';
import getWidth from '../../../utils/gridWidth';
import { withLocale } from '../../Generic/LocaleProvider';
import DOMPurify from 'isomorphic-dompurify';

class CarouselCard extends React.PureComponent {
  render() {
    const { data } = this.props;
    const constants = require(`../../../constants/messages/pt-BR`);
    let cardType = constants.relatedArticles;
    let cardTypestyle =
      (data && data.styles && data.styles.trim()) ||
      cardType ||
      constants.relatedArticles;
    if (cardStyles[cardTypestyle] === undefined) {
      cardTypestyle = cardType;
    }
    let styles = cardStyles[cardTypestyle];
    const mediaProps = {
      type: constants.img,
      src: data.image && data.image.desktopImage && data.image.desktopImage.url,
      alt: data.image && data.image.altText,
      sizes: data.image && data.image.image && data.image.image.sizes,
    };
    let mainWrapper = {
      generic: styles.card.mainWrapper.generic,
      notLastChild: styles.card.mainWrapper.notLastChild,
      lastChild: styles.card.mainWrapper.lastChild,
    };
    let widthClass;
    if (data.componentWidth == null) {
      widthClass = '';
    } else {
      widthClass = getWidth(data.componentWidth);
    }
    let cardMedia = '';
    if (mediaProps.src) {
      cardMedia = (
        <CardMedia
          className={classNames(styles.card.media)}
          image={
            data.image &&
            data.image.smartphoneImage &&
            data.image.smartphoneImage.url
          }
          component={constants.picture}
          sizes={mediaProps.sizes}
          srcset={
            data.image && data.image.desktopImage && data.image.desktopImage.url
          }
          alt={mediaProps.alt}
          cardType={cardType}
          mediaVariant="(min-width: 1024px)"
        />
      );
    }

    let cardMediaLink = '';
    if (
      data.callToActionsCollection &&
      data.callToActionsCollection.items.length > 0
    ) {
      cardMediaLink = (
        <a
          data-pgaction-redirection="0"
          href={
            data.callToActionsCollection &&
            data.callToActionsCollection.items[0].link
          }
          className={classNames([data.gaEventClass])}
          title={
            data.callToActionsCollection &&
            data.callToActionsCollection.items[0].tooltip
          }
        >
          {cardMedia}
        </a>
      );
    } else {
      cardMediaLink = cardMedia;
    }

    let title = '';
    if (data.title) {
      title = (
        <Typography
          component="div"
          className={styles.card.title}
          dangerouslySetInnerHTML={{
            __html:DOMPurify.sanitize( data.title),
          }}
        />
      );
    }

    // Use image alt text for aria-label, fallback to extracting from title
    const imageAltText = data.image && data.image.altText;
    let productName = imageAltText;
    
    if (!productName && data.title) {
      // Extract plain text from title as fallback
      productName = DOMPurify.sanitize(data.title).replace(/<|>/g, '').trim();
    }

    return (
      <Card
        key={data.id}
        className={classNames(
          widthClass,
          mainWrapper.generic,
          mainWrapper.notLastChildNew,
          mainWrapper.lastChild
        )}
      >
        <div 
          className={classNames(cardStyles[cardTypestyle].mediaWrapper)}
          aria-label={productName}
        >
          {cardMediaLink}
          <CardContent className={classNames(styles.card.content)}>
            <div className={classNames(styles.card.titleWrapper)}>
              {title}
              <Typography
                component="div"
                className={styles.card.subtitle}
                dangerouslySetInnerHTML={{
                  __html:DOMPurify.sanitize( data.text),
                }}
              />
              <Button
  
                to={
                  data.callToActionsCollection &&
                  data.callToActionsCollection.items[0].link
                }
                className={classNames(styles.card.header)}
              >
                {data.callToActionsCollection &&
                  data.callToActionsCollection.items[0].linkText}
              </Button>
            </div>
          </CardContent>
        </div>
      </Card>
    );
  }
}

CarouselCard.propTypes = {
  data: PropTypes.oneOfType([PropTypes.object]).isRequired,
};

export default withLocale(CarouselCard);